export default {
      id: "home-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#home",
      toString: function () {
        return this.url;
      }
    }